// NO EDITAR A MANO
import type {FooterLinkApps as Modulo} from "../../../../footer/link_apps";

import descarga_nuestra_app from "./descarga_nuestra_app";
import download_android from "./download_android";
import download_huawei from "./download_huawei";
import download_ios from "./download_ios";
import download_windows from "./download_windows";
import url_android from "./url_android";
import url_android_pro from "./url_android_pro";
import url_huawei from "./url_huawei";
import url_ios from "./url_ios";
import url_ios_pro from "./url_ios_pro";
import url_windows from "./url_windows";

class FooterLinkApps implements Modulo {
    /* STATIC */
    // public static ID: string = "footer.link_apps";
    // public static VERSION: string = "2025.2.11-162203";
    // public static HASH: string = "ebd1c69436c02a2b241538b03052e1f8";

    /* INSTANCE */
    public readonly descarga_nuestra_app: string;
    public readonly download_android: string;
    public readonly download_huawei: string;
    public readonly download_ios: string;
    public readonly download_windows: string;
    public readonly url_android: string;
    public readonly url_android_pro: string;
    public readonly url_huawei: string;
    public readonly url_ios: string;
    public readonly url_ios_pro: string;
    public readonly url_windows: string;

    public constructor() {
        this.descarga_nuestra_app = descarga_nuestra_app;
        this.download_android = download_android;
        this.download_huawei = download_huawei;
        this.download_ios = download_ios;
        this.download_windows = download_windows;
        this.url_android = url_android;
        this.url_android_pro = url_android_pro;
        this.url_huawei = url_huawei;
        this.url_ios = url_ios;
        this.url_ios_pro = url_ios_pro;
        this.url_windows = url_windows;
    }

}

export default new FooterLinkApps();
